/**
 * 优惠券状态
 *
 * Author:   gsm(qq:2479186745)
 * History:
 * Date         Version Remarks
 * ============ ======= ======================================================
 * 2021/1/19      1.0     First version
 *
 * Copyright 2016, all rights reserved. Essa.cn
 * */
import React from 'react';
import PropTypes from "prop-types";
import { Select } from 'antd';
const { Option } = Select;
class Status extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            list: [
                {code:'enable',name:__getServerLanguage('WeiShiYongYouHuiQuan2')},
                {code:'disable',name:__getServerLanguage('YiShiYongYouHuiQuan')},
                {code:'expire',name:__getServerLanguage('YiGuoQiYouHuiQuan')}
            ]
        }
    }

    handleChange(value) {
        this.props.onClickItem(value);
    }




    render(){
        let {list} = this.state;
        return (
            <Select defaultValue={this.props.status} dropdownMatchSelectWidth={false} onChange={this.handleChange.bind(this)}>
                {list.map(function (item,index) {
                    return <Option value={item.code} key={index}>{item.name}</Option>
                })}
            </Select>
        )
    }
}

Status.defaultProps = {
}

Status.propTypes = {

}
export default Status;
